export const createPageInitialValues = {
  title: '',
  wordsPerPage: '50',
  totalPages: '32',
  pageSize: 'us-trade',
  storyContent: '',
  bookStyle: null,
  visualStyle: null,
  writingStyle: null
};